module.exports = "<div id=\"barcode-reader-toggle\">\n    <s-barcode-subscriber v-if=\"enabled\" @close=\"toggle\" />\n</div>\n"